import React from 'react'

class PropertyLabel extends React.Component {
  render() {
    return (
      <div>
        {this.props.ml ? (
          <div>
            <h6 className={`text-${this.props.textcolor}`}>{this.props.name}:</h6>
            <p className={`${this.props.textcolor === null ? 'text-muted' : ''} text-break text-${this.props.textcolor}`}>{this.props.value}</p>
          </div>
         ) : (
          <div className="d-flex justify-content-between">
            <h6 className={`text-${this.props.textcolor}`}>{this.props.name}:</h6>
            {this.props.checkbox ? (
              <input type="checkbox" checked={this.props.value} disabled="true" />
            ) : (
              <span className={`${this.props.textcolor === null ? 'text-muted' : ''} text-${this.props.textcolor}`}>{this.props.value}</span>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default PropertyLabel

